/* Cheecam order card — the state mirror.
 *
 * One reader of the REAL controls (variant pills, occasion chips, the
 * datepicker, quantity, the theme's live price block), three presentations
 * of what it reads:
 *
 *   - the handwritten sentence above the total (concept C)
 *   - the total row pinned to Add to Cart (concept A)
 *   - the sticky desktop receipt (concept B), built here and proxying its
 *     button to the real submit so there is exactly ONE form
 *
 * Nothing in this file writes to the form. The controls stay the source of
 * truth; if this script never runs, the sentence and total stay hidden and
 * the module behaves exactly as before it existed.
 *
 * The price is READ, never computed: the theme's own price block (visually
 * hidden but live — variant changes swap its markup) is mirrored textually.
 * Recomputing money in a second place is how totals drift.
 */
(function () {
  var root = document.querySelector('.product--gl-compact');
  if (!root) return;

  var info = root.querySelector('.product__info-wrapper');
  var priceHost = root.querySelector('[id^="price-"]');
  var sentence = root.querySelector('[data-gl-sentence]');
  var totalRow = root.querySelector('[data-gl-total-row]');
  var totalOut = root.querySelector('[data-gl-total]');
  var submit = root.querySelector('product-form.product-form .product-form__submit');
  var albumMin = parseInt(totalRow && totalRow.getAttribute('data-album-min'), 10) || 6;

  function checkedValue(name) {
    var el = root.querySelector(
      'variant-radios input[type="radio"][name="' + name + '"]:checked, ' +
      'variant-selects input[type="radio"][name="' + name + '"]:checked'
    );
    return el ? el.value : '';
  }

  function state() {
    var tierRaw = checkedValue('Camera Quantity');
    var camsMatch = tierRaw.match(/\((\d+)\s*Cams?\)/i);
    var cams = camsMatch ? parseInt(camsMatch[1], 10) : 0;
    var filmRaw = checkedValue('Pick Your Film Package');
    var occEl = root.querySelector('[data-gl-occasion] input:checked');
    var dateEl = document.getElementById('datepicker-delivery');
    var qtyEl = root.querySelector('.product-form__quantity input[name="quantity"]');
    var priceText = '';
    if (priceHost) {
      var m = priceHost.textContent.match(/\$[\d,]+(?:\.\d{2})?/);
      priceText = m ? m[0].replace(/\.00$/, '') : '';
    }
    return {
      cams: cams,
      tier: cams ? cams + ' cameras' : '',
      tierRaw: tierRaw,
      prints: /physical/i.test(filmRaw),
      film: /physical/i.test(filmRaw) ? 'prints + gallery' : 'digital gallery',
      occ: occEl ? occEl.value.toLowerCase() : '',
      date: dateEl ? (dateEl.value || '') : '',
      qty: qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1,
      priceText: priceText
    };
  }

  function fillBlank(key, value, fallback) {
    if (!sentence) return;
    var el = sentence.querySelector('[data-s="' + key + '"]');
    if (!el) return;
    el.textContent = value || fallback;
    el.classList.toggle('is-empty', !value);
  }

  /* ---- the desktop receipt, built once ---- */
  var receipt = null;
  function buildReceipt() {
    if (receipt || !info) return;
    receipt = document.createElement('aside');
    receipt.className = 'gl-receipt';
    receipt.setAttribute('aria-label', 'Order summary');
    var visualImg = root.querySelector('.gl-module-visual .gl-xfade');
    receipt.innerHTML =
      (visualImg ? '<div class="gl-receipt__visual"></div>' : '') +
      '<div class="gl-receipt__body">' +
      '<h3 class="gl-receipt__title">Your order</h3>' +
      '<dl class="gl-receipt__rows">' +
      '<div><dt>Cameras</dt><dd data-r="tier">—</dd></div>' +
      '<div><dt>Film</dt><dd data-r="film">—</dd></div>' +
      '<div class="gl-receipt__album" data-r-album hidden><dt>Album</dt><dd>Included free</dd></div>' +
      '<div><dt>Celebrating</dt><dd data-r="occ">—</dd></div>' +
      '<div><dt>Arrives by</dt><dd data-r="date">—</dd></div>' +
      '</dl>' +
      '<div class="gl-receipt__total"><span>Total</span><strong data-r="total">—</strong></div>' +
      '<button type="button" class="gl-receipt__cta">Add to cart</button>' +
      '<p class="gl-receipt__trust">Free shipping both ways &middot; retouched until you love them</p>' +
      '</div>';
    if (visualImg) {
      receipt.querySelector('.gl-receipt__visual')
        .appendChild(visualImg.cloneNode(true));
    }
    info.appendChild(receipt);
    /* Span every implicit grid row so position:sticky has the full column to
       travel; children count is only known at runtime. */
    receipt.style.gridRow = '1 / span ' + Math.max(info.children.length - 1, 1);
    receipt.querySelector('.gl-receipt__cta').addEventListener('click', function () {
      /* One form, one submit path: the receipt button is a proxy, so the
         date gate, occasion property and analytics all behave identically. */
      if (submit) submit.click();
    });
  }

  function render() {
    var s = state();
    if (sentence) {
      /* "Corporate" reads wrong in prose ("celebrating corporate with...") —
         Ben asked it to say "corporate event" IN THE SENTENCE only (the
         receipt's labelled "Celebrating: Corporate" field is fine as-is). */
      var occSentence = s.occ === 'corporate' ? 'corporate event' : s.occ;
      fillBlank('occ', occSentence, '______');
      fillBlank('tier', s.tier, '… cameras');
      fillBlank('film', s.film, '…');
      fillBlank('date', s.date, '__/__');
      sentence.hidden = false;
    }
    if (totalRow && totalOut) {
      totalOut.textContent = s.priceText
        ? s.priceText + (s.qty > 1 ? ' × ' + s.qty : '')
        : '—';
      totalRow.hidden = !s.priceText;
    }
    if (receipt) {
      receipt.querySelector('[data-r="tier"]').textContent = s.tier || '—';
      receipt.querySelector('[data-r="film"]').textContent =
        s.film.charAt(0).toUpperCase() + s.film.slice(1);
      receipt.querySelector('[data-r-album]').hidden = !(s.prints && s.cams >= albumMin);
      receipt.querySelector('[data-r="occ"]').textContent = s.occ
        ? s.occ.charAt(0).toUpperCase() + s.occ.slice(1)
        : '—';
      receipt.querySelector('[data-r="date"]').textContent = s.date || '—';
      receipt.querySelector('[data-r="total"]').textContent =
        (s.priceText || '—') + (s.qty > 1 ? ' × ' + s.qty : '');
    }
  }

  /* Gather the post-button paragraph soup (express hint, installments, the
     trust line, the album line) into one bordered card. They are born in
     different parents — the hint is script-injected into the buttons wrapper,
     the installments form is a sibling block, the trust and album lines are
     template blocks — so the composition happens here, where the receipt is
     already composed. moveNode is append-only: with JS off the pieces simply
     stay where the server put them. */
  function buildAfterCard() {
    var buttons = root.querySelector('product-form.product-form .product-form__buttons');
    if (!buttons || buttons.querySelector('.gl-after-cta')) return;
    var card = document.createElement('div');
    card.className = 'gl-after-cta';
    var pieces = [
      buttons.querySelector('.gl-express-hint'),
      (function () {
        var f = root.querySelector('form.installment');
        if (!f) return null;
        var wrap = f.parentElement;
        return (wrap && wrap.children.length === 1) ? wrap : f;
      })(),
      (function () {
        var ps = root.querySelectorAll('p.product__text');
        for (var i = 0; i < ps.length; i++) {
          if (/free shipping both ways/i.test(ps[i].textContent)) return ps[i];
        }
        return null;
      })(),
      root.querySelector('.gl-album-line')
    ];
    var moved = 0;
    pieces.forEach(function (el) { if (el) { card.appendChild(el); moved++; } });
    if (moved) buttons.appendChild(card);
  }

  buildReceipt();
  buildAfterCard();
  render();

  /* Change events cover the pills, chips and quantity. The datepicker is the
     awkward one: jQuery UI writes .val() and the site triggers a jQuery
     'change', which does not reliably reach native listeners — so a slow
     poll backstops it. 700ms is imperceptible for a summary and costs
     nothing measurable. */
  document.addEventListener('change', render);
  document.addEventListener('input', render);
  var lastDate = '';
  setInterval(function () {
    var el = document.getElementById('datepicker-delivery');
    var v = el ? el.value : '';
    if (v !== lastDate) { lastDate = v; render(); }
  }, 700);

  /* Variant switches swap the price block's innerHTML from a fetched section
     render; mirror whatever lands. */
  if (priceHost && 'MutationObserver' in window) {
    new MutationObserver(render).observe(priceHost, { childList: true, subtree: true, characterData: true });
  }
})();
